import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Loading,
  Tab,
  TabPanel,
  Tabs,
} from "../../../../../components";
import {
  ConfiguracoesChecklistService,
  notification,
} from "../../../../../services";
import { responseErros } from "../../../../../utils";
import { AcessoriosAtivoConfiguracao } from "./acessorios-ativo-ordem-servico";
import { AvariasAtivoConfiguracao } from "./avarias-ativo-ordem-servico";

const CheckListOrdemServicoComponent = ({ open, onClose }) => {
  const configuracoesChecklistService = new ConfiguracoesChecklistService();
  const [abaValue, setAbaValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [acessoriosAtivo, setAcessoriosAtivo] = useState([]);
  const [locaisAvaria, setLocaisAvaria] = useState([]);
  const [tiposAvaria, setTiposAvaria] = useState([]);

  useEffect(() => {
    if (open) {
      buscarConfiguracaoChecklist();
    }
  }, [open]);

  const tabProps = (index) => {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  };

  const handleAbaChange = (event, newValue) => {
    setAbaValue(newValue);
  };

  const buscarConfiguracaoChecklist = async () => {
    setLoading(true);
    const response = await configuracoesChecklistService.getAll();
    if (!response.isAxiosError) {
      const dados = response.data || {};
      setAcessoriosAtivo(
        (dados.acessorios || []).map((item) => ({
          id: item.id,
          descricao: item.descricao,
        })),
      );
      setTiposAvaria(
        (dados.tipos || []).map((item) => ({
          id: item.id,
          descricao: item.descricao,
        })),
      );
      setLocaisAvaria(
        (dados.locais || []).map((local) => ({
          id: local.id,
          descricao: local.descricao,
          componentes: (local.componentes || []).map((componente) => ({
            id: componente.id,
            descricao: componente.descricao,
            obrigatoriedade: componente.obrigatoriedade,
          })),
        })),
      );
    } else {
      responseErros(response);
    }
    setLoading(false);
  };

  const idNumerico = (valor) =>
    typeof valor === "number" ||
    (typeof valor === "string" && /^\d+$/.test(valor));

  const getIdSeNumerico = (valor) => {
    if (!idNumerico(valor)) {
      return undefined;
    }
    return Number(valor);
  };

  const handleSalvar = async () => {
    setLoading(true);
    const payload = {
      local: locaisAvaria.map((local) => ({
        ...(getIdSeNumerico(local.id) && { id: getIdSeNumerico(local.id) }),
        descricao: local.descricao,
        componentes: (local.componentes || []).map((componente) => ({
          ...(getIdSeNumerico(componente.id) && {
            id: getIdSeNumerico(componente.id),
          }),
          avariaLocalId: getIdSeNumerico(local.id),
          obrigatoriedade: componente.obrigatoriedade ?? false,
          descricao: componente.descricao,
        })),
      })),
      tipos: tiposAvaria.map((tipo) => ({
        ...(getIdSeNumerico(tipo.id) && { id: getIdSeNumerico(tipo.id) }),
        descricao: tipo.descricao,
      })),
      acessorios: acessoriosAtivo.map((acessorio) => ({
        ...(getIdSeNumerico(acessorio.id) && {
          id: getIdSeNumerico(acessorio.id),
        }),
        descricao: acessorio.descricao,
      })),
    };

    const response = await configuracoesChecklistService.upsert(payload);
    setLoading(false);

    if (!response.isAxiosError) {
      notification.alteracaoSucesso();
      onClose();
    } else {
      responseErros(response);
    }
  };

  return (
    <Dialog fullWidth maxWidth="xl" open={open} onClose={onClose}>
      <DialogTitle className="fw-bold text-uppercase text-center py-4">
        Checklist da Ordem de Serviço
      </DialogTitle>
      <DialogContent>
        <Tabs
          value={abaValue}
          onChange={handleAbaChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          scrollButtons="auto"
        >
          <Tab label="Acessórios do Ativo" {...tabProps(0)} />
          <Tab label="Avarias do Ativo" {...tabProps(1)} />
        </Tabs>
        <TabPanel value={abaValue} index={0}>
          <AcessoriosAtivoConfiguracao
            acessoriosAtivo={acessoriosAtivo}
            setAcessoriosAtivo={setAcessoriosAtivo}
          />
        </TabPanel>
        <TabPanel value={abaValue} index={1}>
          <AvariasAtivoConfiguracao
            locais={locaisAvaria}
            setLocais={setLocaisAvaria}
            tiposAvaria={tiposAvaria}
            setTiposAvaria={setTiposAvaria}
          />
        </TabPanel>
      </DialogContent>
      <DialogActions className="px-4 pb-4">
        <Button variant="contained" color="primary" onClick={handleSalvar}>
          Salvar
        </Button>
        <Button variant="contained" color="padrao" onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
      <Loading loading={loading} />
    </Dialog>
  );
};

export default CheckListOrdemServicoComponent;
